import {Component, OnInit} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {FormInlineRowComponent} from './../forms/form-inline-row';
import {UserService} from './user-service';
import { MessageComponent, BaseComponent } from './../common/common-components';
import { ModalService } from "../services/modal-service";
import { BankAccountService } from "./../accounts/bank-account-service";
declare var ga: any;

@Component({
    selector: 'dk-user-contact-data',
    template: require('./user-contact-data.html'),
    //directives: [FormInlineRowComponent, REACTIVE_FORM_DIRECTIVES, MessageComponent],
    entryComponents: [FormInlineRowComponent]
})

export class UserContactDataComponent extends BaseComponent implements OnInit {
    changeSuccess: boolean;
    public errorMessageId: string;

    form: FormGroup = new FormGroup({
        Phone1: new FormControl('', Validators.required),
        Phone2: new FormControl('')
    });

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private userService: UserService) {
        super();
    }

    load() {
        this.userService.account().subscribe(data => {
            this.initFormGroup(this.form, data);
        });
    }

    ngOnInit() {
        this.load();
    }

    submit() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.changeSuccess = false;
            this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                if (isLocked) {
                    this.errorMessageId = "1004";
                }
                else {
                    this.userService.changeContactData(this.form.value).subscribe(result => {
                        this.changeSuccess = true;
                        ga('send', 'event', 'user', 'zapisano-dane-kontaktowe', null, null, this.form.value);
                        this.load();
                    });
                }
            });
        }
    }
}
